import { put, takeLatest, call } from 'redux-saga/effects'
import { getPositions } from '@/core/apiModules/positions'
import { positionsModule } from '../modules'
import { errorHandler } from '@/core/helpers/errorHelpers'

export function* fetchSaga({ payload }) {
  yield put(positionsModule.toggleLoading(true))

  try {
    const response = yield call(getPositions, payload.hiring_team_id, payload.params)
    yield put(positionsModule.fetchSuccess(response))
  } catch (err) {
    yield call(errorHandler, err)
  }

  yield put(positionsModule.toggleLoading(false))
}

export default function* watchPositionsSaga() {
  yield takeLatest(positionsModule.FETCH, fetchSaga)
}
